module.exports = __webpack_public_path__ + "c7f60f97cf4f0a162d0e8cc650e412b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/e/e06.jpg
// module id = 538
// module chunks = 0